<script>

import Layout from "../../../layouts/main";
import appConfig from "../../../../app.config";
import Detail from "@/views/customer/detail/detail";
import i18n from "@/i18n";


export default {
  page: {
    title: i18n.global.t('menu.business-partner.customer'),
    meta: [{
      name: "description",
      content: appConfig.description,
    },],
  },
  data() {
    return {
      customerId: null,
    };
  },
  components: {
    Layout,
    Detail,
  },
  computed: {

  },
  watch: {

  },
  beforeMount() {
    this.customerId = this.$route.params.id
  },

  methods: {

  },
};
</script>

<template>
  <Layout>
    <detail
        :customer-id="customerId"
        source="business-partner"
        account-permission-code="customer.account.get"
        account-edit-permission-code="customer.account.get"
        other-permission-code="customer.get"
        other-edit-permission-code="customer.get"
    ></detail>
  </Layout>

</template>
